module.exports = __webpack_public_path__ + "teqbahn-assets/media/42.e61ed724.png";